// extracted by mini-css-extract-plugin
export default {"node":"TreeNode-module__node___JCwkf"};